(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const slider = document.querySelector('.home-slider');
    if (!slider) return;

    const autoplay = slider.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(slider.dataset.autoplaySpeed) || 5000;

    // Initialize Slick Slider
    // $(slider).slick({
    //   dots: false,
    //   infinite: true,
    //   speed: 1000,
    //   slidesToShow: 1,
    //   centerPadding: '0px',
    //   slidesToScroll: 1,
    //   autoplay: autoplay,
    //   autoplaySpeed: autoplaySpeed,
    //   arrows: true,
    //   fade: true,
    //   cssEase: 'linear',
    //   adaptiveHeight: true,
    //   centerMode: false,
    // });

    jQuery(slider).slick({
      slidesToShow: 1,
      centerPadding: '0px',
      infinite: true,
      speed: 1000,
      dots: false,
      arrows: true,
      adaptiveHeight: true,
      centerMode: false,
      autoplay: autoplay,
      autoplaySpeed: autoplaySpeed,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    $('.categories-slider').slick({
      slidesToShow: 5,
      centerPadding: '0px',
      infinite: true,
      speed: 1000,
      dots: false,
      arrows: true,
      adaptiveHeight: true,
      centerMode: false,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
          },
        },
        {
          breakpoint: 568,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
          },
        },
      ],
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const slider = document.querySelector('.prodcts-slider');
    if (slider) {
      $(slider).slick({
        slidesToShow: 4,
        centerPadding: '0px',
        infinite: true,
        speed: 1000,
        dots: false,
        arrows: true,
        adaptiveHeight: true,
        centerMode: false,
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
            },
          },
          {
            breakpoint: 568,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
            },
          },
        ],
      });
    }

    // Add to cart functionality
    const addToCartButtons = document.querySelectorAll('.add-to-cart');
    addToCartButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        // The data-product-id now holds the variant ID directly
        const variantId = this.dataset.productId;

        // Add the variant to cart directly
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
              },
            ],
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            /*if (typeof refreshCart === 'function') {
              refreshCart();
            }*/
            window.location.href = '/cart';
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
      jQuery('.review-slider').slick({
        slidesToShow: 1,
        centerPadding: '0px',
        infinite: true,
        speed: 1000,
        dots: true,
        arrows: false,
        adaptiveHeight: true,
        centerMode: false,
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
